import React, { useMemo } from "react";
import { Box, makeStyles } from "@material-ui/core";
import { FTLButton } from "../FTLButton";
import { FTLTypography } from "../FTLTypography";
import classNames from "classnames";
export const FTLPageHeader = ({ title, buttons, BoxProps, }) => {
    const classes = useStyles();
    const buttonComponents = useMemo(() => buttons &&
        buttons.map((button, index) => {
            return (React.createElement(FTLButton, Object.assign({}, button, { key: index, className: classNames(classes.button, button.className) })));
        }), [buttons]);
    return (React.createElement(Box, Object.assign({ display: "flex", justifyContent: "space-between" }, BoxProps),
        React.createElement(FTLTypography, { variant: "h1" }, title),
        React.createElement("div", null, buttonComponents)));
};
const useStyles = makeStyles({
    button: {
        "&:not(:last-of-type)": {
            marginRight: 8,
        },
    },
});
//# sourceMappingURL=index.js.map